import React from 'react'

import clsx from 'clsx'

import Logo from 'components/Logo'
import Typography from 'components/Typography'

import classes from './LogoText.module.scss'

/** @type {import("./types").default} */
const LogoText = ({ className, listing, text = listing.name }) => {
  return (
    <div className={clsx('LogoText', classes.root, className)}>
      <Logo alt={`${listing.name} logo`} className={classes.logo} src={listing.logo_url} size={20} />
      <Typography variant="heading-sm">{text}</Typography>
    </div>
  )
}

export default LogoText
